export default __webpack_public_path__ + "static/media/transfer.fb2e2af6.less";